import React from "react";
import SavedCard from "../../../components/SavedCard";
import Input from "../../../components/Input";
import Button from "../../../components/Button";

const Billing = () => {
  const savedCards = [
    { cardType: "Secondary", bank: "DBL Bank", cardNumber: "**** **** 5600", name: "William" },
    { cardType: "Primary", bank: "XYZ Bank", cardNumber: "**** **** 1234", name: "John Doe" },
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <div className="grid grid-cols-2 gap-4 mb-6">
        <Input label="Accuracy" value="USD" />
        <Input label="Billing" value="Credit" />
      </div>
      <div>
        {savedCards.map((card, index) => (
          <SavedCard
            key={index}
            cardType={card.cardType}
            bank={card.bank}
            cardNumber={card.cardNumber}
            name={card.name}
          />
        ))}
      </div>
      <div className="mt-6 flex justify-end">
        <Button label="Save" color="primary" />
      </div>
    </div>
  );
};

export default Billing;
